/* tslint:disable */
/* eslint-disable */
// @ts-nocheck
/* @relayHash 05fe36f51ebff4f4ac52ac5b34fccd94 */

import { ConcreteRequest } from "relay-runtime";

import { FragmentRefs } from "relay-runtime";
export type ActorType = "GUILDS" | "USERS" | "%future added value";
export type EventVisibility = "DRAFT" | "PRIVATE" | "PUBLIC" | "%future added value";
export type UpdateEventByIdInput = {
    clientMutationId?: string | null | undefined;
    id: string;
    patch: EventPatch;
};
export type EventPatch = {
    rowId?: string | null | undefined;
    ownerId?: string | null | undefined;
    ownerType?: ActorType | null | undefined;
    name?: string | null | undefined;
    description?: string | null | undefined;
    startAt?: string | null | undefined;
    endAt?: string | null | undefined;
    timeZone?: string | null | undefined;
    attendeeLimit?: number | null | undefined;
    externalUrl?: string | null | undefined;
    visibility?: EventVisibility | null | undefined;
    venueId?: string | null | undefined;
    createdAt?: string | null | undefined;
    updatedAt?: string | null | undefined;
    slug?: string | null | undefined;
    coverPhotoId?: string | null | undefined;
    metadata?: unknown | null | undefined;
    eventSeriesId?: string | null | undefined;
};
export type EventScreenSettingsButtonUpdateMutationVariables = {
    input: UpdateEventByIdInput;
};
export type EventScreenSettingsButtonUpdateMutationResponse = {
    readonly updateEventById: {
        readonly event: {
            readonly " $fragmentRefs": FragmentRefs<"EventScreenNewMobile_event" | "EventScreenNewDesktop_event">;
        } | null;
    } | null;
};
export type EventScreenSettingsButtonUpdateMutation = {
    readonly response: EventScreenSettingsButtonUpdateMutationResponse;
    readonly variables: EventScreenSettingsButtonUpdateMutationVariables;
};



/*
mutation EventScreenSettingsButtonUpdateMutation(
  $input: UpdateEventByIdInput!
) {
  updateEventById(input: $input) {
    event {
      ...EventScreenNewMobile_event
      ...EventScreenNewDesktop_event
      id
    }
  }
}

fragment EventAttendButtonHybridAttend_event on Event {
  rowId
  prettyUrl
  hasVenue
  hasExternalUrl
  myAttendance {
    status
    id
  }
  owner {
    __typename
    ... on Guild {
      myMembership {
        membershipLevel
        id
      }
    }
    ... on Node {
      __isNode: __typename
      id
    }
  }
}

fragment EventAttendButtonNew_event on Event {
  rowId
  prettyUrl
  endAt
  hasExternalUrl
  hasVenue
  myAttendance {
    status
    userId
    id
  }
  owner {
    __typename
    ... on Guild {
      slugId
      myMembership {
        membershipLevel
        id
      }
    }
    ... on Node {
      __isNode: __typename
      id
    }
  }
  ...EventAttendButtonSingleAttend_event
  ...EventAttendButtonHybridAttend_event
}

fragment EventAttendButtonSingleAttend_event on Event {
  rowId
  prettyUrl
  hasVenue
  hasExternalUrl
  myAttendance {
    status
    id
  }
  owner {
    __typename
    ... on Guild {
      myMembership {
        membershipLevel
        id
      }
    }
    ... on Node {
      __isNode: __typename
      id
    }
  }
}

fragment EventAttendeesOverlap_eventAttendees on EventAttendeesConnection {
  edges {
    node {
      user {
        firstName
        lastName
        ...UserPrimaryPhotoNew_user
        id
      }
      id
    }
    cursor
  }
}

fragment EventScreenAttendCard_event on Event {
  slug
  startAt
  endAt
  eventAttendeesByRelevance(filter: {status: {in: [ATTENDING_IN_PERSON, ATTENDING_VIRTUAL, WAITING_IN_PERSON]}}, first: 8) {
    totalCount
    ...EventAttendeesOverlap_eventAttendees
  }
  attendingCount: eventAttendees(filter: {status: {in: [ATTENDING_IN_PERSON, ATTENDING_VIRTUAL]}}) {
    totalCount
  }
  waitingCount: eventAttendees(condition: {status: WAITING_IN_PERSON}) {
    totalCount
  }
  myAttendance {
    status
    id
  }
  ...EventAttendButtonNew_event
}

fragment EventScreenDateTime_event on Event {
  slug
  startAt
  endAt
  timeZone
  hasExternalUrl
  myAttendance {
    status
    id
  }
}

fragment EventScreenJoin_event on Event {
  hasVenue
  hasExternalUrl
  externalUrl
  myAttendance {
    status
    id
  }
  venue {
    name
    entryInstructions
    address {
      addressLine1
      addressLine2
      city
      stateProvinceRegionCode
      zipPostalCode
      countryCode
      formattedAddress
      location {
        __typename
        geojson
      }
      id
    }
    id
  }
  owner {
    __typename
    ... on Guild {
      myMembership {
        membershipLevel
        id
      }
    }
    ... on User {
      isMe
    }
    ... on Node {
      __isNode: __typename
      id
    }
  }
}

fragment EventScreenMap_event on Event {
  name
  hasVenue
  venue {
    name
    address {
      addressLine1
      addressLine2
      city
      stateProvinceRegionCode
      zipPostalCode
      countryCode
      formattedAddress
      id
    }
    id
  }
  seoVenue {
    address {
      city
      stateProvinceRegionCode
      zipPostalCode
      countryCode
      location {
        __typename
        geojson
      }
      id
    }
    id
  }
}

fragment EventScreenNewCoverPhoto_event on Event {
  name
  rowId
  prettyUrl
  visibility
  coverPhoto {
    rowId
    contentType
    id
  }
}

fragment EventScreenNewDesktop_event on Event {
  name
  description
  prettyUrl
  startAt
  endAt
  hasVenue
  hasExternalUrl
  seoVenue {
    address {
      city
      stateProvinceRegionCode
      zipPostalCode
      countryCode
      id
    }
    id
  }
  ...EventScreenNewCoverPhoto_event
  ...EventScreenDateTime_event
  ...EventScreenOwner_event
  ...EventScreenSettingsButton_event
  ...EventScreenJoin_event
  ...EventScreenPresentations_event
  ...EventScreenAttendCard_event
  ...EventScreenMap_event
}

fragment EventScreenNewMobile_event on Event {
  name
  description
  prettyUrl
  startAt
  endAt
  hasVenue
  hasExternalUrl
  seoVenue {
    address {
      city
      stateProvinceRegionCode
      zipPostalCode
      countryCode
      id
    }
    id
  }
  ...EventScreenNewCoverPhoto_event
  ...EventScreenSettingsButton_event
  ...EventScreenDateTime_event
  ...EventScreenOwner_event
  ...EventScreenJoin_event
  ...EventScreenPresentations_event
  ...EventScreenAttendCard_event
  ...EventScreenMap_event
}

fragment EventScreenOwner_event on Event {
  owner {
    __typename
    ... on Guild {
      name
      slugId
      primaryPhoto {
        rowId
        id
      }
      ...GuildPrimaryPhotoNew_guild
    }
    ... on User {
      firstName
      lastName
      slugId
      ...UserPrimaryPhotoNew_user
    }
    ... on Node {
      __isNode: __typename
      id
    }
  }
}

fragment EventScreenPresentations_event on Event {
  prettyUrl
  owner {
    __typename
    ... on User {
      isMe
    }
    ... on Guild {
      myMembership {
        membershipLevel
        id
      }
    }
    ... on Node {
      __isNode: __typename
      id
    }
  }
  presentations {
    edges {
      node {
        rowId
        prettyUrl
        title
        description
        presenterFirstName
        presenterLastName
        presenter {
          firstName
          lastName
          ...UserPrimaryPhotoNew_user
          id
        }
        id
      }
      cursor
    }
  }
}

fragment EventScreenSettingsButton_event on Event {
  id
  prettyUrl
  visibility
  hasVenue
  hasExternalUrl
  description
  owner {
    __typename
    ... on Guild {
      myMembership {
        membershipLevel
        id
      }
    }
    ... on User {
      isMe
    }
    ... on Node {
      __isNode: __typename
      id
    }
  }
}

fragment GuildPrimaryPhotoNew_guild on Guild {
  name
  rowId
  primaryPhoto {
    rowId
    contentType
    id
  }
}

fragment UserPrimaryPhotoNew_user on User {
  firstName
  lastName
  rowId
  emailMd5
  primaryPhoto {
    rowId
    contentType
    id
  }
}
*/

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "description",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "prettyUrl",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "city",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "stateProvinceRegionCode",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "zipPostalCode",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "countryCode",
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v10 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v11 = {
  "alias": null,
  "args": null,
  "concreteType": null,
  "kind": "LinkedField",
  "name": "location",
  "plural": false,
  "selections": [
    (v10/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "geojson",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v12 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "rowId",
  "storageKey": null
},
v13 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "contentType",
  "storageKey": null
},
v14 = [
  (v12/*: any*/),
  (v13/*: any*/),
  (v9/*: any*/)
],
v15 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "slugId",
  "storageKey": null
},
v16 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "firstName",
  "storageKey": null
},
v17 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "lastName",
  "storageKey": null
},
v18 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "emailMd5",
  "storageKey": null
},
v19 = {
  "alias": null,
  "args": null,
  "concreteType": "Image",
  "kind": "LinkedField",
  "name": "primaryPhoto",
  "plural": false,
  "selections": (v14/*: any*/),
  "storageKey": null
},
v20 = [
  (v16/*: any*/),
  (v17/*: any*/),
  (v12/*: any*/),
  (v18/*: any*/),
  (v19/*: any*/),
  (v9/*: any*/)
],
v21 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "cursor",
  "storageKey": null
},
v22 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "totalCount",
  "storageKey": null
},
v23 = [
  (v22/*: any*/)
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "EventScreenSettingsButtonUpdateMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "UpdateEventPayload",
        "kind": "LinkedField",
        "name": "updateEventById",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Event",
            "kind": "LinkedField",
            "name": "event",
            "plural": false,
            "selections": [
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "EventScreenNewMobile_event"
              },
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "EventScreenNewDesktop_event"
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "EventScreenSettingsButtonUpdateMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "UpdateEventPayload",
        "kind": "LinkedField",
        "name": "updateEventById",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Event",
            "kind": "LinkedField",
            "name": "event",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              (v3/*: any*/),
              (v4/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "startAt",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "endAt",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "hasVenue",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "hasExternalUrl",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "Venue",
                "kind": "LinkedField",
                "name": "seoVenue",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Address",
                    "kind": "LinkedField",
                    "name": "address",
                    "plural": false,
                    "selections": [
                      (v5/*: any*/),
                      (v6/*: any*/),
                      (v7/*: any*/),
                      (v8/*: any*/),
                      (v9/*: any*/),
                      (v11/*: any*/)
                    ],
                    "storageKey": null
                  },
                  (v9/*: any*/)
                ],
                "storageKey": null
              },
              (v12/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "visibility",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "Image",
                "kind": "LinkedField",
                "name": "coverPhoto",
                "plural": false,
                "selections": (v14/*: any*/),
                "storageKey": null
              },
              (v9/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": null,
                "kind": "LinkedField",
                "name": "owner",
                "plural": false,
                "selections": [
                  (v10/*: any*/),
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "GuildMembership",
                        "kind": "LinkedField",
                        "name": "myMembership",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "membershipLevel",
                            "storageKey": null
                          },
                          (v9/*: any*/)
                        ],
                        "storageKey": null
                      },
                      (v2/*: any*/),
                      (v15/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Image",
                        "kind": "LinkedField",
                        "name": "primaryPhoto",
                        "plural": false,
                        "selections": [
                          (v12/*: any*/),
                          (v9/*: any*/),
                          (v13/*: any*/)
                        ],
                        "storageKey": null
                      },
                      (v12/*: any*/)
                    ],
                    "type": "Guild",
                    "abstractKey": null
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "isMe",
                        "storageKey": null
                      },
                      (v16/*: any*/),
                      (v17/*: any*/),
                      (v15/*: any*/),
                      (v12/*: any*/),
                      (v18/*: any*/),
                      (v19/*: any*/)
                    ],
                    "type": "User",
                    "abstractKey": null
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      (v9/*: any*/)
                    ],
                    "type": "Node",
                    "abstractKey": "__isNode"
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "slug",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "timeZone",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "EventAttendee",
                "kind": "LinkedField",
                "name": "myAttendance",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "status",
                    "storageKey": null
                  },
                  (v9/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "userId",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "externalUrl",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "Venue",
                "kind": "LinkedField",
                "name": "venue",
                "plural": false,
                "selections": [
                  (v2/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "entryInstructions",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Address",
                    "kind": "LinkedField",
                    "name": "address",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "addressLine1",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "addressLine2",
                        "storageKey": null
                      },
                      (v5/*: any*/),
                      (v6/*: any*/),
                      (v7/*: any*/),
                      (v8/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "formattedAddress",
                        "storageKey": null
                      },
                      (v11/*: any*/),
                      (v9/*: any*/)
                    ],
                    "storageKey": null
                  },
                  (v9/*: any*/)
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "PresentationsConnection",
                "kind": "LinkedField",
                "name": "presentations",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "PresentationsEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Presentation",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v12/*: any*/),
                          (v4/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "title",
                            "storageKey": null
                          },
                          (v3/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "presenterFirstName",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "presenterLastName",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "User",
                            "kind": "LinkedField",
                            "name": "presenter",
                            "plural": false,
                            "selections": (v20/*: any*/),
                            "storageKey": null
                          },
                          (v9/*: any*/)
                        ],
                        "storageKey": null
                      },
                      (v21/*: any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": [
                  {
                    "kind": "Literal",
                    "name": "filter",
                    "value": {
                      "status": {
                        "in": [
                          "ATTENDING_IN_PERSON",
                          "ATTENDING_VIRTUAL",
                          "WAITING_IN_PERSON"
                        ]
                      }
                    }
                  },
                  {
                    "kind": "Literal",
                    "name": "first",
                    "value": 8
                  }
                ],
                "concreteType": "EventAttendeesConnection",
                "kind": "LinkedField",
                "name": "eventAttendeesByRelevance",
                "plural": false,
                "selections": [
                  (v22/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "EventAttendeesEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "EventAttendee",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "User",
                            "kind": "LinkedField",
                            "name": "user",
                            "plural": false,
                            "selections": (v20/*: any*/),
                            "storageKey": null
                          },
                          (v9/*: any*/)
                        ],
                        "storageKey": null
                      },
                      (v21/*: any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": "eventAttendeesByRelevance(filter:{\"status\":{\"in\":[\"ATTENDING_IN_PERSON\",\"ATTENDING_VIRTUAL\",\"WAITING_IN_PERSON\"]}},first:8)"
              },
              {
                "alias": "attendingCount",
                "args": [
                  {
                    "kind": "Literal",
                    "name": "filter",
                    "value": {
                      "status": {
                        "in": [
                          "ATTENDING_IN_PERSON",
                          "ATTENDING_VIRTUAL"
                        ]
                      }
                    }
                  }
                ],
                "concreteType": "EventAttendeesConnection",
                "kind": "LinkedField",
                "name": "eventAttendees",
                "plural": false,
                "selections": (v23/*: any*/),
                "storageKey": "eventAttendees(filter:{\"status\":{\"in\":[\"ATTENDING_IN_PERSON\",\"ATTENDING_VIRTUAL\"]}})"
              },
              {
                "alias": "waitingCount",
                "args": [
                  {
                    "kind": "Literal",
                    "name": "condition",
                    "value": {
                      "status": "WAITING_IN_PERSON"
                    }
                  }
                ],
                "concreteType": "EventAttendeesConnection",
                "kind": "LinkedField",
                "name": "eventAttendees",
                "plural": false,
                "selections": (v23/*: any*/),
                "storageKey": "eventAttendees(condition:{\"status\":\"WAITING_IN_PERSON\"})"
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "id": "48a3db9a2c6391e7c4536450a38ab26a1646e3f9c0a05a936e152a791f6a1627",
    "metadata": {},
    "name": "EventScreenSettingsButtonUpdateMutation",
    "operationKind": "mutation",
    "text": null
  }
};
})();
(node as any).hash = '6be0d53f0b752d00339c1993e4b06cb2';
export default node;
